import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getMyReferral, validateReferralCode, type ValidateReferralResponse } from '../api/referrals';

const REFERRAL_QUERY_KEY = ['referral', 'me'];

export function useMyReferral() {
  return useQuery({
    queryKey: REFERRAL_QUERY_KEY,
    queryFn: getMyReferral,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

export function useValidateReferralCode() {
  const queryClient = useQueryClient();

  return useMutation<ValidateReferralResponse, Error, string>({
    mutationFn: validateReferralCode,
    onSuccess: () => {
      // Invalidate referral data if validation succeeds (though we don't know until we check response)
      queryClient.invalidateQueries({ queryKey: REFERRAL_QUERY_KEY });
    },
  });
}
